import * as React from "react";
import MyRenderer from "./MyRenderer.ts";
import App from "./App";
// eslint-disable-next-line no-unused-vars
import i18n from "./i18n";
import "./polyfills.js";
import { RootProvider } from "./context/RootProvider";

MyRenderer.render(
  <RootProvider>
    <App />
  </RootProvider>,
  document.getElementById("root"),
);



// WEBPACK FOOTER //
// ./src/index.js